module.exports = __webpack_public_path__ + "img/u2213.a878f676.svg";